import axios from "axios";
import Config from "../../../config/index";
import { CREATE_CUSTODY_FAILURE, CREATE_CUSTODY_REQUEST, CREATE_CUSTODY_SUCCESS, EDIT_CUSTODY_FAILURE, EDIT_CUSTODY_REQUEST, EDIT_CUSTODY_SUCCESS, GET_CUSTODY_FAILURE, GET_CUSTODY_FROM_FAILURE, GET_CUSTODY_FROM_REQUEST, GET_CUSTODY_FROM_SUCCESS, GET_CUSTODY_REQUEST, GET_CUSTODY_SUCCESS, GET_DELETE_CUSTODY_FAILURE, GET_DELETE_CUSTODY_REQUEST, GET_DELETE_CUSTODY_SUCCESS, GET_INSERT_PONUMBER_FAILURE, GET_INSERT_PONUMBER_fg_FAILURE, GET_INSERT_PONUMBER_fg_REQUEST, GET_INSERT_PONUMBER_fg_SUCCESS, GET_INSERT_PONUMBER_REQUEST, GET_INSERT_PONUMBER_SUCCESS, GET_LOCATION_FROM_CUSTODY_FAILURE, GET_LOCATION_FROM_CUSTODY_REQUEST, GET_LOCATION_FROM_CUSTODY_SUCCESS, GET_PO_NUMBER_FAILURE, GET_PO_NUMBER_REQUEST, GET_PO_NUMBER_SUCCESS, UPLOAD_CUSTODY_FAILURE, UPLOAD_CUSTODY_REQUEST, UPLOAD_CUSTODY_SUCCESS, UPLOAD_URL_FAILURE, UPLOAD_URL_REQUEST, UPLOAD_URL_SUCCESS } from "./custodyTypes";


let baseUrl = Config.baseUrl;
let baseUrlFileUploadTemp = Config.baseUrlFileUploadTemp;

const getCustodyRequest = () => {
  return {
    type: GET_CUSTODY_REQUEST,
  };
};

const getCustodySuccess = (payload) => {
  return {
    type: GET_CUSTODY_SUCCESS,
    payload: payload,
  };
};

const getCustodyFailure = (error) => {
  return {
    type: GET_CUSTODY_FAILURE,
    payload: error,
  };
};

const getCustody = (dppId, jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };

  return (dispatch) => {
    dispatch(getCustodyRequest());

    let url;

    // If dppId is provided → fetch data only for that DPP
    if (dppId) {
      url = `${baseUrl}/dpp/get_chain_of_custody_bydpp?dppId=${dppId}`;
    } else {
      // If no dppId → fetch all data
      url = `${baseUrl}/dpp/get_chain_of_custody`;
    }

    axios
      .get(url, headers)
      .then((response) => {
        dispatch(getCustodySuccess(response.data));
      })
      .catch((err) => {
        dispatch(getCustodyFailure(err.message));
      });
  };
};


const getLocationFromCustodyRequest = () => {
  return {
    type: GET_LOCATION_FROM_CUSTODY_REQUEST,
  };
};

const getLocationFromCustodySuccess = (payload) => {
  return {
    type: GET_LOCATION_FROM_CUSTODY_SUCCESS,
    payload: payload,
  };
};

const getLocationFromCustodyFailure = (error) => {
  return {
    type: GET_LOCATION_FROM_CUSTODY_FAILURE,
    payload: error,
  };
};

const getLocationFromCustody = (dppId,jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(getLocationFromCustodyRequest());
    let url = `${baseUrl}/dpp/get_chain_of_custody_from_location?dppId=${dppId}`;
    axios
      .get(url, headers)
      .then((response) => {
        dispatch(getLocationFromCustodySuccess(response.data));
      })
      .catch((err) => {
        dispatch(getLocationFromCustodyFailure(err.message));
      });
  };
};

const getFromEntityFromDppIdRequest = () => {
  return {
    type: GET_CUSTODY_FROM_REQUEST,
  };
};

const getFromEntityFromDppIdSuccess = (payload) => {
  return {
    type: GET_CUSTODY_FROM_SUCCESS,
    payload: payload,
  };
};

const getFromEntityFromDppIdFailure = (error) => {
  return {
    type: GET_CUSTODY_FROM_FAILURE,
    payload: error,
  };
};

const getFromEntityFromDppId = (dppId,jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(getFromEntityFromDppIdRequest());
    let url = `${baseUrl}/dpp/get_chain_of_custody_from_entity?dppId=${dppId}`;
    axios
      .get(url, headers)
      .then((response) => {
        dispatch(getFromEntityFromDppIdSuccess(response.data));
      })
      .catch((err) => {
        dispatch(getFromEntityFromDppIdFailure(err.message));
      });
  };
};


const deleteCustodyRequest = () => {
  return {
    type: GET_DELETE_CUSTODY_REQUEST,
  };
};

const deleteCustodySuccess = (payload) => {
  return {
    type: GET_DELETE_CUSTODY_SUCCESS,
    payload: payload,
  };
};

const deleteCustodyFaliure = (error) => {
  return {
    type: GET_DELETE_CUSTODY_FAILURE,
    payload: error,
  };
};

const deleteCustody = (chainId,udBy, jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };

  return (dispatch) => {
    dispatch(deleteCustodyRequest());
    // let url = `${baseUrl}/dpp/product_passport/delete?dppId=${dppId}`;
    
    let url = `${baseUrl}/dpp/delete_chain_of_custody?chainId=${chainId}&udBy=${udBy}`;
    // let url = `${baseUrl}/mvtmap?id=${productId}`;
    // let url = `/mvtmap?id=334`;
    return axios
      .delete(url, {}, headers)
      .then((response) => {
        dispatch(deleteCustodySuccess(response.data));
        return { status: true, data: response.data };
      })
      .catch((err) => {
        dispatch(deleteCustodyFaliure(err.response));
        return { status: false, data: err.response };
      });
  };
};


const createCustodyRequest = () => {
  return {
    type: CREATE_CUSTODY_REQUEST,
  };
};

const createCustodySuccess = (payload) => {
  return {
    type: CREATE_CUSTODY_SUCCESS,
    payload: payload,
  };
};

const createCustodyFailure = (error) => {
  return {
    type: CREATE_CUSTODY_FAILURE,
    payload: error,
  };
};

const createCustody = (payload, jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(createCustodyRequest());
    let url = `${baseUrl}/dpp/create_chain_of_custody`;
    return axios
      .post(url, payload, headers)
      .then((response) => {
        dispatch(createCustodySuccess(response.data));
        return { status: true, data: response.data };
      })
      .catch((err) => {
        dispatch(createCustodyFailure(err.response));
        return { status: false, data: err.response };
      });
  };
};


const editCustodyRequest = () => {
  return {
    type: EDIT_CUSTODY_REQUEST,
  };
};

const editCustodySuccess = (payload) => {
  return {
    type: EDIT_CUSTODY_SUCCESS,
    payload: payload,
  };
};

const editCustodyFailure = (error) => {
  return {
    type: EDIT_CUSTODY_FAILURE,
    payload: error,
  };
};

const editCustody = (payload, jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(editCustodyRequest());
    let url = `${baseUrl}/dpp/update_chain_of_custody`;
    return axios
      .post(url, payload, headers)
      .then((response) => {
        dispatch(editCustodySuccess(response));
        return { status: true, data: response.data };
      })
      .catch((err) => {
        dispatch(editCustodyFailure(err.response));
        return { status: false, data: err.response };
      });
  };
};


const uploadForCustodyRequest = () => {
  return {
    type: UPLOAD_CUSTODY_REQUEST,
  };
};

const uploadForCustodySuccess = (payload) => {
  return {
    type: UPLOAD_CUSTODY_SUCCESS,
    payload: payload,
  };
};

const uploadForCustodyFailure = (error) => {
  return {
    type: UPLOAD_CUSTODY_FAILURE,
    payload: error,
  };
};

const uploadForCustody = (payload, jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(uploadForCustodyRequest());
    let url = `${baseUrlFileUploadTemp}/dpp_custody/upload`;
    return axios
      .post(url, payload, headers)
      .then((response) => {
        dispatch(uploadForCustodySuccess(response.data));
        return { status: true, data: response.data };
      })
      .catch((err) => {
        dispatch(uploadForCustodyFailure(err.response));
        return { status: false, data: err.response };
      });
  };
};

const uploadForUrlRequest = () => {
  return {
    type: UPLOAD_URL_REQUEST,
  };
};

const uploadForUrlSuccess = (payload) => {
  return {
    type: UPLOAD_URL_SUCCESS,
    payload: payload,
  };
};

const uploadForUrlFailure = (error) => {
  return {
    type: UPLOAD_URL_FAILURE,
    payload: error,
  };
};

const uploadForUrl = (payload, jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(uploadForUrlRequest());
    let url = `${baseUrl}/dpp/s3/upload`;
    return axios
      .post(url, payload, headers)
      .then((response) => {
        dispatch(uploadForUrlSuccess(response.data));
        return { status: true, data: response.data };
      })
      .catch((err) => {
        dispatch(uploadForUrlFailure(err.response));
        return { status: false, data: err.response };
      });
  };
};


const getPoNumberByDppIdRequest = () => {
  return {
    type: GET_PO_NUMBER_REQUEST,
  };
};

const getPoNumberByDppIdSuccess = (payload) => {
  return {
    type: GET_PO_NUMBER_SUCCESS,
    payload: payload,
  };
};

const getPoNumberByDppIdFailure = (error) => {
  return {
    type: GET_PO_NUMBER_FAILURE,
    payload: error,
  };
};

const getPoNumberByDppId = (dppId,jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(getPoNumberByDppIdRequest());
    let url = `${baseUrl}/dpp/product_passport/get_po_with_batch_number?dppId=${dppId}`;
    axios
      .get(url, headers)
      .then((response) => {
        dispatch(getPoNumberByDppIdSuccess(response.data));
      })
      .catch((err) => {
        dispatch(getPoNumberByDppIdFailure(err.message));
      });
  };
};


const getInsertPoNumberRequest = () => {
  return {
    type: GET_INSERT_PONUMBER_REQUEST,
  };
};

const getInsertPoNumberSuccess = (payload) => {
  return {
    type: GET_INSERT_PONUMBER_SUCCESS,
    payload: payload,
  };
};

const getInsertPoNumberFailure = (error) => {
  return {
    type: GET_INSERT_PONUMBER_FAILURE,
    payload: error,
  };
};

const getInsertPoNumber = (poNumber,dppId,jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(getInsertPoNumberRequest());
    let url = `${baseUrl}/dpp/rmtracebility_insert_from_po?poNumber=${poNumber}&dppId=${dppId}`;
    axios
      .get(url, headers)
      .then((response) => {
        dispatch(getInsertPoNumberSuccess(response.data));
      })
      .catch((err) => {
        dispatch(getInsertPoNumberFailure(err.message));
      });
  };
};

const getInsertPoNumberProductionRequest = () => {
  return {
    type: GET_INSERT_PONUMBER_fg_REQUEST,
  };
};

const getInsertPoNumberProductionSuccess = (payload) => {
  return {
    type: GET_INSERT_PONUMBER_fg_SUCCESS,
    payload: payload,
  };
};

const getInsertPoNumberProductionFailure = (error) => {
  return {
    type: GET_INSERT_PONUMBER_fg_FAILURE,
    payload: error,
  };
};

const getInsertPoNumberProduction = (poNumber,dppId,jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(getInsertPoNumberProductionRequest());
    // let url = `${baseUrl}/dpp/rmtracebility_insert_from_po?poNumber=${poNumber}&dppId=${dppId}`;
    let url = `${baseUrl}/dpp/fg_operation_log_insert_from_po?poNumber=${poNumber}&dppId=${dppId}`;
    axios
      .get(url, headers)
      .then((response) => {
        dispatch(getInsertPoNumberProductionSuccess(response.data));
      })
      .catch((err) => {
        dispatch(getInsertPoNumberProductionFailure(err.message));
      });
  };
};



 

export {
  getCustody,
  deleteCustody,
  createCustody,
  editCustody,
  getFromEntityFromDppId,
  getLocationFromCustody,
  uploadForCustody,
  uploadForUrl,
  getPoNumberByDppId,
  getInsertPoNumber,
  getInsertPoNumberProduction

  //  getDocumentTypeWithPagination
  //  , createDocumentType
};
